import { getConfig } from '@townsquare/config';

import CollaborationGraphProvider from './collab-graph-provider';

const config = getConfig();

export const resolvedCollabGraphProvider: CollaborationGraphProvider =
	new CollaborationGraphProvider(config.collabGraphUrl);
